app.PersistentGrid = (
    function () {
    var member = {
        Init: function (tableName) {

            //We must run this line of code to make sure that
            //filters persist when they push the back button        
            var grids = app.page.components[tableName];
            var previousPageNumber = $("#LastPageNumber").val();
            var previousPageSize = $("#LastPageSize").val();
            var previousSortField = $("#LastSortField").val();
            var previousIsSortAscending = $("#LastIsSortAscending").val();

            $(grids).each(function () {
                this.refreshGrid(previousPageNumber, previousPageSize, previousSortField, previousIsSortAscending);
            });

            $(document).on("component-bind-view-mode-complete", function (e) {
                //If this is less than one, than we know that there is only one page
                //of results, so make sure to change any remebered page numbers since
                //depending on the order there could be one stored in this scenario

                if ($("ul.pagination").length < 1) {
                    $("#LastPageNumber").val(1);
                }

                //Rememeber Page Number
                $("div[data-component-type='" + tableName + "']  li > a[data-role='grid-page-action']").on("click", function (e) {
                    var selectedPageNumber = $(this).data("page-value");
                    $("#LastPageNumber").val(selectedPageNumber);
                });

                //Remember Page Size
                $("div[data-component-type='" + tableName + "']  select[name='PageSize']").on("click", function (e) {
                    $("#LastPageSize").val($("select[name='PageSize'] > option:selected").val());
                });

                $("div[data-component-type='" + tableName + "']  a[data-role='sort-action']").on("click", function (e) {
                    $("#LastIsSortAscending").val($(this).hasClass("asc"));
                    $("#LastSortField").val($(this).data("target"));
                });
            });
        }
    };
    return member;
}());